module.exports = __webpack_public_path__ + "img/SQUID和Z线的自动布局-规则.b501b86a.svg";